import React from 'react'

import { tr } from '@/utils/utils'

import Exception from '@/components/Exception'
import { Link } from 'react-router-dom'

function Exception500() {
  return (
    <Exception
      type="500"
      desc={tr('app.exception.description.500')}
      linkElement={Link}
      backText={tr('app.exception.back')}
    />
  )
}

export default Exception500
